import { Progress } from '@/generic/progress';
import type { DiagnosticReport } from '@/diagnostic/domain/DiagnosticReport.ts';

type DiagnosticProgressBuilder = {
  progress: Progress;
};

export class DiagnosticProgress {
  readonly #progress: Progress;

  private constructor(builder: DiagnosticProgressBuilder) {
    this.#progress = builder.progress;
  }

  static of(builder: DiagnosticProgressBuilder): DiagnosticProgress {
    return new DiagnosticProgress(builder);
  }

  get progress(): Progress {
    return this.#progress;
  }
}

export class DiagnosticCompleted {
  readonly #report: DiagnosticReport;

  private constructor(report: DiagnosticReport) {
    this.#report = report;
  }

  static of(report: DiagnosticReport): DiagnosticCompleted {
    return new DiagnosticCompleted(report);
  }

  get report(): DiagnosticReport {
    return this.#report;
  }
}

export class DiagnosticNotFollowed extends Error {
  private constructor(cause: unknown) {
    super(cause instanceof Error ? cause.message : String(cause), { cause });
  }

  static of(cause: unknown): DiagnosticNotFollowed {
    return new DiagnosticNotFollowed(cause);
  }
}

export type Diagnostic = DiagnosticProgress | DiagnosticCompleted | DiagnosticNotFollowed;
